const routes = [
  {
    index: true,
    label: 'Nikita Smirnov',
    path: '/',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
  {
    label: 'eSign-BY',
    path: '/eSign',
  },
];

export default routes;

/*   {
    label: 'About',
    path: '/about',
  },

  {
    label: 'Stats',
    path: '/stats',
  },
*/
